import { defineMessages } from 'react-intl';

export const messages: {
	justNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	justNow: {
		id: 'com.atlassian.migrations-platform.mpt-timeago.ui.just-now',
		defaultMessage: 'just now',
		description: 'Label for "just now" relative time',
	},
});
